import { Boolean, Number, Record, String } from 'runtypes';

export const DocumentDetailExtrasRunType = Record({
	shouldShowTheClaimButton: Boolean,
});

export const DocumentDetailSpoingExtrasRunType = Record({
	documentBoxId: Number,
});

export const DocumentExtrasRunType = Record({
	category: String,
	documentBoxId: String,
	documentMayBeDeleted: Boolean,
	format: String,
	shouldShowTheClaimButton: Boolean,
	version: String,
});
